/**
 * ACCS Site-Specific Configuration
 * Provides brand-specific settings and overrides for the ACCS deployment
 */

export interface SiteConfig {
  // Brand identifier
  brand: 'accs' | 'creditdirect'

  // Display name
  displayName: string

  // Cloudflare Pages project name
  cloudflareProject: string

  // Optional: Site-specific Webflow domain
  webflowDomain?: string

  // Optional: Custom tracking parameters
  tracking?: {
    gtmContainerId?: string
    customDimensions?: Record<string, string>
  }

  // Optional: Site-specific styling or behavior flags
  features?: {
    enableAddressAutocomplete?: boolean
    enableFieldFormatting?: boolean
    enableComponentRenderer?: boolean
    debugMode?: boolean
  }
}

const accsConfig: SiteConfig = {
  brand: 'accs',
  displayName: 'ACCS (American Consumer Credit Solutions)',
  cloudflareProject: 'webflow-scripts',
  webflowDomain: 'shawns-accs-poc.webflow.io',

  tracking: {
    // GTM container ID if specific to ACCS
    gtmContainerId: undefined, // Add if needed
    customDimensions: {
      site: 'accs',
      brand: 'accs'
    }
  },

  features: {
    enableAddressAutocomplete: true,
    enableFieldFormatting: true,
    enableComponentRenderer: true,
    debugMode: process.env.NODE_ENV === 'development'
  }
}

export default accsConfig
